const SELECTOR = ".dropdown-portal";
const NS = "dropdownPortal";

const collectScrollParents = (element) => {
  const parents = [];
  let el = element.parentElement;
  while (el) {
    const style = window.getComputedStyle(el);
    const overflow = `${style.overflow}${style.overflowY}${style.overflowX}`;
    if (/(auto|scroll|overlay)/.test(overflow)) parents.push(el);
    el = el.parentElement;
  }
  return parents;
};

let bound = false;

const initBodyDropdownMenu = () => {
  if (bound) return;
  bound = true;

  $(document).on(`shown.bs.dropdown`, SELECTOR, function () {
    const $parent = $(this);
    let $menu = $parent.data("dropdownPortalMenu");
    if (!$menu || !$menu.length) {
      $menu = $parent.find(".dropdown-menu");
      $parent.data("dropdownPortalMenu", $menu);
    }
    const $toggle = $parent.find(".dropdown-toggle");
    const previousCleanup = $parent.data("dropdownPortalScrollCleanup");
    if (typeof previousCleanup === "function") previousCleanup();

    const instance = $toggle.data("bs.dropdown");
    if (instance && instance._popper) {
      instance._popper.destroy();
      instance._popper = null;
    }
    $menu.detach().appendTo("body");

    const updatePosition = () => {
      if (!$toggle.length || !$toggle[0].isConnected) return;
      const rect = $toggle[0].getBoundingClientRect();
      $menu.css({
        position: "fixed",
        top: `${rect.bottom}px`,
        left: "auto",
        right: `${window.innerWidth - rect.right}px`,
        zIndex: 1050,
      });
    };

    updatePosition();

    const scrollParents = collectScrollParents($toggle[0]);
    $(window).on(`scroll.${NS} resize.${NS}`, updatePosition);
    scrollParents.forEach((node) => {
      node.addEventListener("scroll", updatePosition, { passive: true });
    });

    $parent.data("dropdownPortalScrollCleanup", () => {
      $(window).off(`.${NS}`, updatePosition);
      scrollParents.forEach((node) => {
        node.removeEventListener("scroll", updatePosition);
      });
      $parent.removeData("dropdownPortalScrollCleanup");
    });
  });

  $(document).on(`hidden.bs.dropdown`, SELECTOR, function () {
    const $parent = $(this);
    const cleanup = $parent.data("dropdownPortalScrollCleanup");
    if (typeof cleanup === "function") cleanup();

    const $menu = $parent.data("dropdownPortalMenu");
    if (!$menu || !$menu.length) return;
    if ($menu.parent()[0] === document.body) {
      $menu.css({ position: "", top: "", left: "", right: "", zIndex: "" });
      $menu.appendTo($parent);
    }
  });
};

module.exports = initBodyDropdownMenu;
